import React, { useState } from 'react'
import './Viewprofile.css'

import bdate from "../../imgs/bdate.png";
import gender from "../../imgs/gender.png";
import marrstatus from "../../imgs/marrstatus.png";
import district from "../../imgs/district.png";
import bgrp from "../../imgs/bgrp.png";
import community from "../../imgs/community.png";
import profession from "../../imgs/profession.png";
import income from "../../imgs/income.png";
import education from "../../imgs/education.png";
import navras from "../../imgs/navras.png";
import naksh from "../../imgs/naksh.png";
import gan from "../../imgs/gan.png";
import nadi from "../../imgs/nadi.png";
import gotra from "../../imgs/gotra.png";
import kdvt from "../../imgs/kdvt.png";
import devak from "../../imgs/devak.png";
import whitecall from "../../imgs/whitecall.png";
import address from "../../imgs/address.png";
import play from "../../imgs/play.png";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'

const Viewprofile = (props) => {
    const navigate = useNavigate();

    const [showfeednew, setShowfeednew] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [DataSource, setDataSource] = useState([]);
    const [input, setInput] = useState({ notes: "", nextdate: "" });
    const [loading, setLoading] = useState(false);
    const notify = (msg) => toast(msg);

    const savenote = (srr) => {
        if (input.notes !== "") {
            let rawData = {
                notes: input.notes,
                nextdate: input.nextdate,
                usersr: srr,
                brsr: localStorage.getItem("brno"),

            }
            rawData = JSON.stringify(rawData)
            let formData = new FormData()
            formData.append('data', rawData)

            axios.post('https://softtesting.in/php/cust/savefeedbackweb.php', formData, {
                'Content-Type': 'multipart/form-data',

            }).then(function sample(response) {

                if (response.data === "Feedback Saved!") {

                    notify(response.data);
                    getfeedback(srr);
                    shownewfeed();
                    setInput({ notes: "", nextdate: "" });
                }
                else {
                    notify("Please check date!");
                }
            }).catch(err => {
                console.log(err);
            });
        }
        else {
            notify("Please fill data!");
        }
    }

    const updatenote = (srr, status, usersr) => {

        let rawData = {
            sr: srr,
            status: status,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/updatenotestatusweb.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            if (response.data === "Updated Successfully!") {

                notify(response.data);
                getfeedback(usersr);

            }

        }).catch(err => {
            console.log(err);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const valuecurrent = event.target.value;

        setInput(value => ({ ...value, [name]: valuecurrent }))
    }

    const shownewfeed = () => {
        setShowfeednew(!showfeednew);
    }

    const handleImageError = () => {
        setImageError(true);
    };

    const handleshowfeed = (sr) => {
        props.setShowfeed(!props.showfeed);
        getfeedback(sr);
    }

    const openfdetails = () => {
        navigate("/feeddetails");
    }

    const getfeedback = (srrr) => {
        setDataSource([]);
        let rawData = {
            usersr: srrr,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://softtesting.in/php/cust/getfeedbackweb.php', formData, {
            'Content-Type': 'multipart/form-data',

        }).then(function sample(response) {
            console.log("feed- ", response.data);
            setDataSource(response.data);

        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <div className="fullprofile">
            {props.DataSourcepr.map((user, index) => (

                <div className="outermodal">
                    <div className="modalmain">
                        {/* <img onClick={handlephoto} className='profileimg' src={`https://softtesting.in/${path}/${user.sr}.jpg`} alt="" /> */}

                        <img
                            onClick={props.handlephoto}
                            className={`profileimg ${props.path === 'photo' ? 'slide-transition' : ''}`}
                            src={`https://softtesting.in/${props.path}/${user.sr}.jpg`}
                            alt=""
                        />

                        <div className="mattermain">
                            <div className="profilematter">
                                <div className="card">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>माझे नाव</span>
                                    </div>
                                    <span className='cardmatter'>{user.name}</span>
                                </div>
                            </div>
                            <div className="profilematter">
                                <div className="card">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>माझी अपेक्षा</span>
                                    </div>
                                    <span className='cardmatter'>{user.stavar}</span>
                                </div>
                            </div>
                            <div className="profilematter">
                                <div className="card">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>प्राथमिक माहिती</span>
                                    </div>
                                    <div className="namerow">
                                        <div className="greencircle"><span className='cardmatter'>प्रोफाईल क्रमांक - {user.sr}</span></div>
                                        <div className="greencircle"><span className='cardmatter'>वर्ण - {user.vrn}</span></div>
                                        <div className="greencircle"><span className='cardmatter'>{user.age} Yrs old</span></div>
                                        <div className="greencircle"><span className='cardmatter'>उंची {user.height}"</span></div>
                                    </div>

                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={bdate} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>जन्मदिनांक व जन्मवेळ</span>
                                                <span className='regular'>{user.bdate},{user.vel}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={gender} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>युजर प्रकार</span>
                                                <span className='regular'>{user.vtype}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={marrstatus} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>लग्न प्रकार</span>
                                                <span className='regular'>{user.vtype}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={district} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>जिल्हा</span>
                                                <span className='regular'>{user.vtype}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={bgrp} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>रक्तगट</span>
                                                <span className='regular'>{user.vtype}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle">
                                                <img className='smalllogo3' src={community} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>जात/समाज</span>
                                                <span className='regular'>{user.vtype}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modalmain">
                        <div className="mattermain">
                            <div className="profilematter">
                                <div className="card22">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>पारिवारीक व कौटुंबिक माहिती</span>
                                    </div>
                                    <span className='cardmatter'>माझ्या वडिलांचे नाव {user.fname} आहे,माझ्या आईचे नाव {user.mname} आहे,मला {user.bro} भाऊ आहेत व {user.sis} आहेत. माझे आजोळ/मामाचे नाव {user.ajol} आहे.<br />आमचे पाहुणे {user.pahune} या प्रकार आहेत.</span>
                                </div>
                            </div>
                        </div>
                        <div className="mattermain">
                            <div className="profilematter">
                                <div className="card22">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>शैक्षणिक व करिअर माहिती</span>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={profession} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>सध्याचे काम</span>
                                                <span className='regular'>{user.cjob}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={profession} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>काम प्रकार</span>
                                                <span className='regular'>{user.cjobdetails}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={income} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>आपले वार्षिक उत्पन्न</span>
                                                <span className='regular'>{user.kmai}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={education} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>शिक्षण</span>
                                                <span className='regular'>{user.qulidetails} ( {user.quli} )</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="modalmain">
                        <div className="mattermain">
                            <div className="profilematter">
                                <div className="card3">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>इतर माहिती</span>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={navras} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>नावरस नाव</span>
                                                <span className='regular'>{user.navras}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={naksh} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>नक्षत्र</span>
                                                <span className='regular'>{user.naksh}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={gan} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>गण</span>
                                                <span className='regular'>{user.gan}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={nadi} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>नाडी</span>
                                                <span className='regular'>{user.nadi}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={gotra} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>गोत्र</span>
                                                <span className='regular'>{user.gotra}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={kdvt} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>कुलदैवत</span>
                                                <span className='regular'>{user.kdvt}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle3">
                                                <img className='smalllogo3' src={devak} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>देवक</span>
                                                <span className='regular'>{user.devak}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mattermain">
                            <div className="profilematter">
                                <div className="card3">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>संपर्क माहिती</span>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={whitecall} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>मोबाईल क्रमांक</span>
                                                <span className='regular'>{props.contactdata.mobno}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={whitecall} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>इतर मोबाईल क्रमांक</span>
                                                <span className='regular'>{props.contactdata.amobno}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="namerow">
                                        <div className="ppoint">
                                            <div className="imgcircle2">
                                                <img className='smalllogo3' src={address} alt="" />
                                            </div>
                                            <div className="pointmatter">
                                                <span className='regularbold'>संपूर्ण पत्ता</span>
                                                <span className='regular'>{props.contactdata.address}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="linecard"></div>
                                    <div className="usecountmain">
                                        {props.user === "cust" ?
                                            props.showconfirm ?
                                                <div className="usecount">
                                                    <div className="cardmessage">
                                                        <span className="regularbold">काऊंट वापरुन मोबाईल पहायची?</span>
                                                        <span className="regular">(शिल्लक काऊंट- {user.count - user.ucount},प्लान समाप्त- {localStorage.getItem("fdate")},आजचे शिल्लक काऊंट- {1}) </span>
                                                        <div className="buttonrow">
                                                            <button type="button" onClick={props.showcontacts} className='btn btn-primary my-1 mx-1'>होय</button>
                                                            <button type="button" onClick={props.confirmcontact} className='btn btn-primary my-1'>नाही</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="confirview">
                                                    <span className='regularbold'>{props.exist === "exist" ? "सदर स्थळाची माहिती वरील प्रमाणे आहे." : "स्थळाचा मोबाईल क्रमांक व पत्ता पाहण्यासाठी"}</span>
                                                    <div onClick={props.exist === 'exist' ? props.sendtomadhysti : props.confirmcontact} className="usercountbutton">
                                                        <span className='regularblue'>{props.exist === "exist" ? "मदती साठी पाठवा" : "काऊंट वापरुन मोबाईल पहा."}</span>
                                                    </div>
                                                </div>

                                            :
                                            props.user === "madh" ?
                                                <div className='madh'>
                                                    <div className="rowmadh">
                                                        <img className='smalllogo' src={play} alt="" />   
                                                        <span className='regularbold'> Play Recording</span>
                                                    
                                                    </div>
                                                    <span className='regularbold'> Response- {user.notes ? user.notes : "No any response yet"}</span>

                                                </div>

                                                : <div className="confirview">
                                                    <span className='regularbold'>सदर स्थळाची माहिती वरील प्रमाणे आहे.</span>
                                                    <div onClick={() => handleshowfeed(user.sr)} className="usercountbutton">
                                                        <span className='regularblue'>Feedbck Details</span>
                                                    </div>
                                                </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.showfeed ?
                        <div className="mattermainfull">
                            <div className="profilematter">
                                <div className="card3">
                                    <div className="redline" />
                                    <div className="headcard">
                                        <span className='cardtitle'>Feedbck Details</span>

                                    </div>
                                    <div className="rowfeedback">
                                        <div className="colfeedback">
                                            <span className='regularbold'>Profile Image</span>
                                            <div className="linecard"></div>
                                            <img
                                                className='profileimgfeed'
                                                src={`https://softtesting.in/${props.path}/${user.sr}.jpg`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="colfeedback">
                                            <span className='regularbold'>Biodata Image</span>
                                            <div className="linecard"></div>

                                            {!imageError ? (
                                                <img
                                                    src={`https://softtesting.in/bphoto/${user.sr}.jpg`}
                                                    onError={handleImageError}
                                                    alt='Original Image'
                                                    className='profileimgfeed'
                                                />
                                            ) : (
                                                <img
                                                    src={`https://softtesting.in/${props.path}/${user.sr}.jpg`}
                                                    alt='Alternate Image'
                                                    className='profileimgfeed'
                                                />
                                            )}

                                        </div>

                                        <div className="colfeedback">
                                            <span className='regularbold'>History <span onClick={shownewfeed} className='bluebold'>( New Followup ) </span></span>
                                            <div className="linecard"></div>
                                            {showfeednew ?
                                                <div className="colfeedback2">
                                                    <span className='regulr'>Follwup Note</span>
                                                    <input className="form-control search" type="text" id="notes" name="notes" onChange={handleChange} placeholder='Enter Note' />
                                                    <span className='regulr'>Next Follwup Date</span>
                                                    <input className="form-control search" type="date" id="nextdate" name="nextdate" onChange={handleChange} placeholder='Select Date' />
                                                    <div onClick={() => savenote(user.sr)} className="buttonregi">
                                                        <span className="regularboldregi">{loading ? "Please Wait.." : "Save"}</span>
                                                    </div>

                                                </div>
                                                :
                                                <table id="table-to-xls" className="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th className='regularbold' scope="col">Sr</th>
                                                            <th className='regularbold' scope="col">Note</th>
                                                            <th className='regularbold' scope="col">Date</th>
                                                            <th className='regularbold' scope="col">Update</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {DataSource && DataSource.length > 0 && DataSource.map((feedback, index) =>
                                                            <tr key={index + 1}>
                                                                <td className={feedback.status === "Yes" ? `green` : 'regular'}>{index + 1}</td>
                                                                <td className={feedback.status === "Yes" ? `green` : 'regular'}>{feedback.notes}</td>
                                                                <td className={feedback.status === "Yes" ? `green` : 'regular'}>{feedback.nextdate}</td>
                                                                <td className={feedback.status === "Yes" ? `green` : 'regular'}><UilEditAlt onClick={() => updatenote(feedback.sr, feedback.status, feedback.usersr)} className="ic" /></td>
                                                            </tr>
                                                        )}

                                                    </tbody>
                                                </table>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ""}
                </div>
            ))}
            <ToastContainer />
        </div>
    )
}

export default Viewprofile
